// const { load } = require("debug/src/browser");
// const { join } = require("path");
// const { features } = require("process");
// var window.global.mapCfg = window.global.window.global.mapCfg
// var map=window.global.map
import { Message } from "element-ui";
// import { param } from "jquery";
import { getSingleWeather,getWeatherData } from "../http/axios";
import VectorSource from 'ol/source/Vector';
import Image from "ol/layer/Image"
import ImageStatic from "ol/source/ImageStatic"
import Interaction from 'ol/interaction/Interaction.js';
// import { Point, MultiLineString, LineString, Circle } from 'ol/geom';
// import GeoJSON from "ol/format/GeoJSON";
// import { Style, Fill as olFill, Stroke, Icon as olIcon, Text as olText, Circle as olCircle } from "ol/style";
// import { Feature } from 'ol';
// import { Polygon, MultiPolygon } from 'ol/geom';
// import VectorLayer from "ol/layer/Vector";
import { transform } from "ol/proj";

import Overlay from "ol/Overlay";

// import * as turf from '@turf/turf'

import gfsData from '../../public/conf/common/gfs.json'
import { WindLayer } from "ol-wind";
// let echarts = require('echarts/lib/echarts');
// import ol3Echarts from 'ol-echarts/dist/ol-echarts';


let windJsonData = []
let weatherLayer = null;
let protectionElectricLayer=null
let windLayer = null;
let lastPublishtime = ""
let opacity=0.75;
let lastShowCoor=null
let lastShowName="";

var weatherTipOverlay = null;
function disableWeatherLayer(w)
{
    if(w=="wind")
    {    
        if (window.global.windLayer != null) {
            try
            {
                window.global.map.removeLayer(window.global.windLayer);
            }
            catch(err) {
            }
        }
        windLayer = null;
        window.global.windLayer=null
    }
    else if(window.global.weatherLayer != null)
    {
 
        // let mapRect =  window.global.map.getView().calculateExtent( window.global.map.getSize());
        // let iSt=new ImageStatic({
        //     url: "",
        //     imageExtent: mapRect,
        //     });
        weatherLayer.setVisible(false);   
    }
}


function destoryWeatherLayer() {
    
    window.closeLoading("weather");
    if (weatherLayer != null) {
        window.global.map.removeLayer(weatherLayer);
        
    }
    weatherLayer = null;
    window.global.weatherLayer = null;
    if (window.global.windLayer != null) {
        try
        {
            window.global.map.removeLayer(window.global.windLayer);
        }
        catch(err) {
        }
    }
    windLayer = null;
    window.global.weatherType=[]
    window.global.windLayer=null
}


function createWeatherLayer() {
    let mapRect = window.global.map.getView().calculateExtent(window.global.map.getSize());
    console.log("start create weather layer");
    // weatherType = window.global.weatherType;
    if (weatherLayer != null) {
        window.global.map.removeLayer(weatherLayer);
        weatherLayer=null;
    }
    weatherLayer=new Image({
        opacity: opacity,
        source: new ImageStatic({
            url: "",
            imageExtent: mapRect,
            imageLoadFunction:function(image, src) {
                loadOtherData(image);
                // image.getImage().src = l.url+"?format=png&transparent=true&dpi=96&bboxSR=2385&imageSR=2385&f=image&access_token=64b60040-5181-455f-a47c-4c795190a5fc&bbox="+p2385Rect.join(',')+"&size="+width+","+height;
            }
        })
    });
    weatherLayer.setZIndex(parseInt(window.global.weatherCfg.layerIndex));
    // let publishtime = "2023-03-04 00:00:00";
    window.global.map.addLayer(weatherLayer);
    window.global.weatherLayer=weatherLayer
    createWeatherTipLayer()
    // loadOtherData();
}
function getPointsWeather(positions,ids,allWeather)
{
    
    let timeArr =window.global.weatherTime.split(" ")
    //  let timeStr ="2023-07-24" +" "+ timeArr[1]
    
    let timeStr =timeArr[0] +" "+ timeArr[1]
    var params = {
        type: allWeather?"all":window.global.weatherType.join(","),
        ids:ids,
        time:timeStr,
        point: positions
    };
    
    window.showLoading("weather");
    getSingleWeather(params).then(res => {
        window.closeLoading("weather");
        if (res.status==200) 
        {
            let t = res.data;
            return t;
        }
    });
}
function createWindLayer() {

    
    if(!window.global.weatherType.includes("wind"))
        return ;

    let mapRect = window.global.map.getView().calculateExtent(window.global.map.getSize());
    let curZoom = window.common.getMapZoomInt(); //获取当前地图的缩放级别
    let p4326Rect = [];
    let tp = transform([mapRect[0], mapRect[1]], 'EPSG:3857', 'EPSG:4326');
    let br = transform([mapRect[2], mapRect[3]], 'EPSG:3857', 'EPSG:4326');
    
    p4326Rect[0] = tp[0];
    p4326Rect[1] = tp[1];
    p4326Rect[2] = br[0];
    p4326Rect[3] = br[1];
    
    if (window.global.windLayer != null) {
        try
        {
            window.global.map.removeLayer(window.global.windLayer);
        }
        catch(err) {
        }
    }
    windLayer = null;
    window.global.windLayer =null
    let timeArr =window.global.weatherTime.split(" ")
    //  let timeStr ="2023-07-24" +" "+ timeArr[1]

    
    let timeStr =timeArr[0] +" "+ timeArr[1]    


    var params = {
        type: "wind",
        time: timeStr,
        bbox: p4326Rect.join(","),
        zoom: curZoom,
        srs: 4326
    };
    window.showLoading("wind");
    getWeatherData(params).then((response) => {
        window.closeLoading("wind");
        let t = response.data
        return t;
    }).then((data) => {
        
        if(!window.global.weatherType.includes("wind"))
            return ;
        if(data.hasOwnProperty("error") || !data.config.hasOwnProperty("publishtime"))
        {
           
            return
        }

         if (data.datas.length == 0) {
                Message.warning({
                    message: "请求气象数据为空...",
                    type: 'warning',
                    offset:100,
                });
        } else {
            let dataInfo=data.config;

            if(window.global.weatherTime != dataInfo.publishtime &&
                lastPublishtime !=dataInfo.publishtim)
            {
                Message.info({
                    message: "当前气象数据日期为:"+dataInfo.publishtime,
                    type: 'info',
                    offset:100,
                });
            }
            lastPublishtime=dataInfo.publishtim;


            windJsonData = []
            let dataRect=dataInfo.rect.split(",");
            let minLat = parseFloat(dataRect[0])
            let minLon = parseFloat(dataRect[1])
            let maxLat = parseFloat(dataRect[2])
            let maxLon = parseFloat(dataRect[3])
            
            // let minLat = parseFloat(p4326Rect[0])
            // let minLon = parseFloat(p4326Rect[1])
            // let maxLat = parseFloat(p4326Rect[2])
            // let maxLon = parseFloat(p4326Rect[3])

            let nx = 0;
            let ny = 0;
            let speedData=data.datas["speed"];
            let angleData=data.datas["angle"];
            gfsData[0].data = [];
            gfsData[1].data = [];
            for(ny=0;ny<speedData.length;ny++)
            {
                
                let sr=speedData[ny];
                let ar=angleData[ny];
                for(nx=0;nx<sr.length;nx++)
                {
                    let angle = parseFloat(ar[nx])
                    let speed = parseFloat(sr[nx])
                    let radian = angle * Math.PI / 180;    //计算出弧度
                    let nSpeed = speed * Math.sin(radian)
                    let eSpeed =  (speed * Math.cos(radian) * (-1))

                    gfsData[0].data.push(eSpeed);
                    gfsData[1].data.push(nSpeed);                   
                }

            }
  

            // let p = [minLat,minLon];// transform([minLon,minLat], 'EPSG:4326', 'EPSG:3857')

            gfsData[0].header.lo1 = minLat
            gfsData[0].header.la1 = minLon

            gfsData[1].header.lo1 = minLat
            gfsData[1].header.la1 = minLon

            // p = [maxLon, maxLat]; //transform([maxLon,maxLat], 'EPSG:4326', 'EPSG:3857')

            gfsData[0].header.lo2 = maxLat
            gfsData[0].header.la2 = maxLon

            gfsData[1].header.lo2 = maxLat
            gfsData[1].header.la2 = maxLon
            gfsData[0].meta.date=dataInfo.publishtime
            gfsData[1].meta.date=dataInfo.publishtime



           

            let dx = parseFloat(dataInfo.grid.lat);// Math.abs(maxLon - minLon) / (nx - 1)
            let dy = parseFloat(dataInfo.grid.lon);//Math.abs(maxLat - minLat) / (ny - 1)

            gfsData[0].header.nx = nx
            gfsData[0].header.ny = ny
            gfsData[0].header.dx = dx
            gfsData[0].header.dy = dy
            gfsData[0].header.numberPoints = ny * nx;

            gfsData[1].header.nx = nx
            gfsData[1].header.ny = ny
            gfsData[1].header.dx = dx
            gfsData[1].header.dy = dy
            gfsData[1].header.numberPoints = ny * nx;

         
            windJsonData = gfsData
            return windJsonData
        }

    }).then((windJsonData) => {


        if (windLayer != null) {
            window.global.map.removeLayer(windLayer);
            windLayer=null;
        }
        curZoom = window.common.getMapZoomFloat()
        let windSpeed = window.global.weatherCfg.windspeed
        let colorScales = window.global.weatherCfg.colorScales
        windLayer = new WindLayer(windJsonData, {
            forceRender: false,
            windOptions: {
                globalAlpha:0.95,
                velocityScale: () => {
                    return (windSpeed[curZoom]*1.5) || 1 / 40;
                },
                paths: 100,
                maxAge: 15,
                colorScale: (m) => {
                    let t = getWindColorIndex(Math.round(m))
                    return colorScales[t] || "#00b3ef";
                    // return "#00b3ef";
                },
                frameRate: 10,
                lineWidth: 3,
                generateParticleOption: false,
                className:"ol-wind-layer"
                // 风场图层挡住了其他的标注点位 然后就按照文档设置了zIndex 并没有什么卵用那么解决办法如下。然后就可以按照你设置的zIndex生效了。很尿性哦
            },
            // map: map,
            projection: 'EPSG:4326',
            fieldOptions: {
            },
        });
        let windLayerSource = new VectorSource({
            wrapX: false
        })
        windLayer.getSource = function () {
            return windLayerSource
        }
        window.global.windLayer = windLayer

        windLayer.setZIndex(parseInt(window.global.weatherCfg.layerIndex)+1);
        window.global.map.addLayer(windLayer);
    })


}

function getWindColorIndex(v) {
    if (v < 2) {
        return 0
    }
    if (v >= 2 && v <= 3) {
        return 1
    }
    if (v >= 4 && v <= 5) {
        return 2
    }
    if (v >= 6 && v <= 7) {
        return 3
    }
    if (v >= 8 && v <= 9) {
        return 4
    }
    if (v >= 10 && v <= 14) {
        return 5
    }
    if (v >= 15 && v <= 19) {
        return 6
    }
    if (v >= 20 && v <= 24) {
        return 7
    }
    if (v >= 25 && v <= 29) {
        return 8
    }
    if (v >= 30 && v <= 34) {
        return 9
    }
    if (v >= 35 && v <= 39) {
        return 10
    }
    if (v >= 40) {
        return 11
    }
}

function convertCoords(coords) {
    if (Array.isArray(coords[0])) {
        return coords.map(convertCoords);
    } else {
        let convertedCoords = transform(coords, 'EPSG:4326', 'EPSG:3857')
        return convertedCoords;
    }
}

function loadOtherData(image) {
    // jl, mapRect, projCode, vectorSource, success, failur
    //if weater is open .get weather type by layername
    // let vectorSource = weatherLayer.ol.getSource()
    // console.log(vectorSource)
    

     
    let map=window.global.map;
    let mapRect = map.getView().calculateExtent(map.getSize());
    let loadit=0;
    let wType=""
    for(let i=0;i<window.global.weatherType.length;i++)
    {
        if(window.global.weatherType[i]!="wind")
        {
            wType=window.global.weatherType[i];
            break
        }
    }

    if(wType == "")
        return;
    let pixel = map.getPixelFromCoordinate([mapRect[0],mapRect[1]]);
    let tx = pixel[0];
    let ty= pixel[1];

    pixel = map.getPixelFromCoordinate([mapRect[2],mapRect[3]]);
    let bx = pixel[0] ;
    let by= pixel[1];
    let width = parseInt(bx-tx);
    let height = parseInt(ty-by);
    // console.log(width,height);
    let curZoom = parseInt(Math.round(map.getView().getZoom())); //获取当前地图的缩放级别
    let p4326Rect = [];
    let tp = transform([mapRect[0], mapRect[1]], 'EPSG:3857', 'EPSG:4326');
    let br = transform([mapRect[2], mapRect[3]], 'EPSG:3857', 'EPSG:4326');
    p4326Rect[0] = tp[0];
    p4326Rect[1] = tp[1];
    p4326Rect[2] = br[0];
    p4326Rect[3] = br[1];
    let timeArr =window.global.weatherTime.split(" ")
    //  let timeStr ="2023-07-24" +" "+ timeArr[1]
    let timeStr =timeArr[0] +" "+ timeArr[1]

    var params = {
        type: wType,
        time: timeStr,
        bbox: p4326Rect.join(","),
        width:width,
        height:height,
        zoom: curZoom,
        srs: 4326
    };
    
    // weatherLayer.setVisible(false);
    window.showLoading("weather");

    getWeatherData(params).then((response) => {
        let t = response.data;
        window.closeLoading("weather");
        
        // let t={"config": {"publishtime": "2023-03-04 00:00:00", "lonMin": "118.15737830960265", "lonMax": "123. 17583399642925", "latMin": " 27.770263448945357", "latMax": " 30.019925443643146"},"url": "weather/17_118.15737830960265_27.770263448945357_123.17583399642925_30.019925443643146.png"};
        return t;
        
    }).then((weatherData) => {
        if(weatherData.hasOwnProperty("error"))
        {
            return 
        }
        
        let dataInfo=weatherData.config;
        if(!dataInfo.hasOwnProperty("publishtime"))
        {
            weatherLayer.setVisible(false);
            return 
        }
        wType="";
        for(let i=0;i<window.global.weatherType.length;i++)
        {
            if(window.global.weatherType[i]!="wind")
            {
                wType=window.global.weatherType[i];
                break
            }
        }
    
        if(wType == "")
            return;
        if(window.global.weatherTime != dataInfo.publishtime &&
            lastPublishtime !=dataInfo.publishtim)
        {
            Message.info({
                message: "当前气象数据日期为:"+dataInfo.publishtime,
                type: 'info',
                offset:100,
            });
        }
        lastPublishtime=dataInfo.publishtim;
        let dataRect=dataInfo.rect.split(",");
        tp = transform([parseFloat(dataRect[0]), parseFloat(dataRect[1])], 'EPSG:4326', 'EPSG:3857');
        br = transform([parseFloat(dataRect[2]), parseFloat(dataRect[3])], 'EPSG:4326', 'EPSG:3857');

        // let dataRect=[];
        dataRect[0] = tp[0];
        dataRect[1] = tp[1];
        dataRect[2] = br[0];
        dataRect[3] = br[1];
        let iSt=new ImageStatic({
            url: weatherData.url,
            imageExtent: dataRect,
            });
        weatherLayer.setSource(iSt);
        weatherLayer.setVisible(true);
    
    })


}

function setWeatherOpacity(val) {
    opacity = val/100;
    if(weatherLayer!=null){
        weatherLayer.setOpacity(val/100)
    }
};


let weatherTimer = null;

function loadWeatherData()
{
    if(weatherTimer!=null)
        clearTimeout(weatherTimer);
    weatherTimer = setTimeout(() => {
        createWindLayer();    
        loadOtherData(null);
        if(weatherTipDisplayed())
            showPointWeather(lastShowCoor,lastShowName)
    }, 50) 
}
function showPointWeather(coor,tname)
{
    //气象模式下点击了空白的区域
    if(coor==null)
        return ;
    lastShowCoor = coor;
    lastShowName = tname;
    let pos = transform(coor, 'EPSG:3857', 'EPSG:4326')
    pos = [parseFloat(pos[0].toFixed(4)), parseFloat(pos[1].toFixed(4))]

    let timeArr =window.global.weatherTime.split(" ")
    //  let timeStr ="2023-07-24" +" "+ timeArr[1]
    
     let timeStr =timeArr[0] +" "+ timeArr[1]
    var params = {
        type: "all",
        time: timeStr,
        point: pos.join(" ")
    };
    window.showLoading("pointWeather");
    getSingleWeather(params).then(res => {
        window.closeLoading("pointWeather");
        
        if (res.status==200) 
        {
            
            if(res.data.hasOwnProperty("error"))
            {
                return 
            }
            let t = res.data[0]
            let noData=0;
            if(!t.hasOwnProperty("publishtime")|| t.datas.length<=0)
            {
                noData=1
            }
            let leftMenuItem = []
            let w=t.datas[0].datas;
            let publishtimeText = noData?"":`${t.publishtime}`
            let temperatureText = noData||!w.temperature||w.temperature.toLowerCase()=="nan"?"-":`${parseFloat(w.temperature).toFixed(1)}`+ "°C"
            let windspeed_10mTextV = noData||!w.speed||w.speed.toLowerCase()=="nan"?"":`${parseFloat(w.speed).toFixed(1)}`
            let windspeed_10mTextA = noData||!w.angle||w.angle.toLowerCase()=="nan"?"-":`${windDirection(parseInt(w.angle))}`
            let solarradiationText = noData||!w.radiation||w.radiation.toLowerCase()=="nan"?"-":`${parseFloat(w.radiation).toFixed(2)}`+"W/m2"
            let rainfallText = noData||!w.rain||w.rain.toLowerCase()=="nan"?0:`${parseFloat(w.rain).toFixed(2)}`
            let humidnessText = noData||!w.humidness||w.humidness.toLowerCase()=="nan"?"-":`${parseFloat(w.humidness).toFixed(2)}`+ "%" 
            
            leftMenuItem = [
                { title: "温度", "name": temperatureText ,icon:"img/icon/temperature.png"},
                { title: "湿度", "name": humidnessText  ,icon:"img/icon/humidness.png"},
                { title: "", "name": rianfall2Text(rainfallText),icon:"img/icon/rainfall.png" },
                { title: "辐射", "name": solarradiationText ,icon:"img/icon/radiation.png"},
                { title: "", "name": windspeed_10mTextA+" "+windspeed2Text(windspeed_10mTextV) ,icon:"img/icon/windspeed.png"},
                // { title: "风向", "name": windspeed_10mTextA == "undefined" ? "" : windspeed_10mTextA ,icon:"img/icon/windangle.png"},
                // { title: "时间", "name": publishtimeText == "undefined" ? "" : publishtimeText,icon:"img/icon/clock.png" },
                
                ]
            
                // let tlist=publishtimeText.substring(5,13).split(" ")
                // let tdlist=tlist[0].split("-")
                // publishtimeText=tdlist[0]+"月"+tdlist[1]+"日"+tlist[1]+"时"+" 无气象数据"
                // leftMenuItem.push({ title: "", "name": publishtimeText,icon:"img/icon/error.png" })

            if(typeof tname != "undefined" && tname!="")
            {
                leftMenuItem.unshift({ title: "", "name": tname+" ",icon:"img/icon/location.png" })
            }
            else
            {
                leftMenuItem.unshift({ title: "位置", "name": pos.join(" "),icon:"img/icon/location.png" })

            }
  
                // window.setSiteInformation(tname + " " + tid + " " + className + " " + tgeolayerName);
            window.setSiteInformation(null);
            window.setLeftMenuItem(leftMenuItem)
            weatherTipOverlay.setPosition(coor);
        } 
    })
}



function changeWeatherData2Text(d)
{
    let wText=""
    for(let v in d)
    {
        if(d[v]=="" || d[v].toLowerCase()=="nan")
            return ""
        if(v=="temperature")
        {
            wText= parseInt(d[v])+"° C"
            return wText;
        }
        else if(v=="humidness")
        {
            return parseInt(d[v])+"%"
        }
        else if(v=="rain")
        {
            return parseInt(d[v])+"mm";
        }
        else if(v=="radiation")
        {
            return parseInt(d[v])+"W/m2";
        }
        else if(v=="speed")
        {
            if(wText=="")
                wText=parseInt(d[v])+"m/s"
            else
                return wText+" "+parseInt(d[v])+"m/s"
        }
        else if(v=="angle")
        {
            if(wText=="")
                wText=windDirection(d[v])
            else
                return windDirection(d[v])+" "+wText;

        }
    }
    return wText;
}

function windspeed2Text(speed)
{
    if(speed=="")
        return "";
    let fspeed=parseFloat(speed);
    let speedText=speed+"m/s"
    let speedArray=[
    [0,"无风",0.0, 0.3],
    [1,"软风",	0.3	,1.6],
    [2,"轻风",1.6,3.3],
    [3,"微风",	3.4	,5.4],
    [4,"和风",	5.5	,7.9],
    [5,"清风",	8.0	,10.7],
    [6,"强风",	10.8,	13.8],
    [7,"劲风",    13.9,	17.1],
    [8,"大风",	17.2,	20.7],
    [9,"烈风",	20.8,	24.4],
    [10,"狂风",	24.5,	28.4],
    [11,"暴风",	28.5,	32.6],
    [12,"台风",    32.7,	36.9],
    [13,"台风",    37.0	,41.4],
    [14,"强台风",  41.5,	46.1],
    [15,"强台风",  46.2	,50.9],
    [16,"超强台风",    51.0,	56.0],
    [17,"超强台风", 56.1	,61.2],
    [18,"超强台风", 61.3,	10000]];
    speedArray.forEach(t => {
        if(fspeed>=t[2] && fspeed<(t[3]+0.1))
        {
            speedText= ""+t[0]+"级 "+speed+"m/s "+t[1]
            return
        }
    }); 
    return speedText
}

function rianfall2Text(rain)
{
    let frain=parseFloat(rain);
    let rainText=rain+"mm"
    let rainArray=[
        ["无雨",0.1],
        ["小雨",10],
        ["中雨",25],
        ["大雨",50],
        ["暴雨",100],
        ["大暴雨",250],
        ["特大暴雨",10000]];

    for(let i=0;i<rainArray.length;i++)
    {
        if(frain<rainArray[i][1])
            if(i==0)
                return rainArray[i][0]
            else
                return rainArray[i][0]+" "+rainText
    }
    return rainText
}



function windDirection(val) {
    let directionText=[
        "东",
        "东南",
        "南",
        "西南",
        "西",
        "西北",
        "北",
        "东北",
    ]
    let angle=parseFloat(val);
    angle=(angle+22.5);
    if((angle)>=360)
        angle-=360;
    let num=parseInt((angle)/45);
    return directionText[num]+"风"

}

function weatherTipDisplayed()
{
    if(weatherTipOverlay == null)
        return false;
    if(weatherTipOverlay.getPosition()!=undefined)
        return true;
    else
        return false;
}
function createWeatherTipLayer()
{
    let map=window.global.map;
    var element = window.getWeatherTipElement()

    weatherTipOverlay = new Overlay({
        element: element[0],
        positioning: "bottom-left",
        offset: [0, 0],
        autoPan: true,
        stopEvent: true,
        insertFirst: true,
        className: "", //必須置空，不然overlay click事件不行
        autoPanMargin: 200,
        autoPanAnimation: {
          duration: 250, //当Popup超出地图边界时，为了Popup全部可见，地图移动的速度.
        },
      });
      window.global.map.addOverlay(weatherTipOverlay);
      weatherTipOverlay.setPosition(undefined);

   
    // map.getInteractions().forEach(function(interaction){
    //     if (interaction instanceof Interaction.DragPan) {
    //         weatherDragPan = interaction;  
    //     }
    // });

    element[1].addEventListener('mousedown', function(evt) {
        // weatherDragPan.setActive(false);
        weatherTipOverlay.set('dragging', true);
        // console.info('start dragging');
    });
    
}

function weatherTipDragging(evt)
{
    if(!weatherTipDisplayed())
        return
    if (weatherTipOverlay.get('dragging')) {
        weatherTipOverlay.setPosition(evt.coordinate);
  }
}

function closeWeatherTip()
{
    if(!weatherTipDisplayed())
        return
    weatherTipOverlay.setPosition(undefined);
}
function weatherTipDragOver(evt)
{
    if(!weatherTipDisplayed())
        return
    if (weatherTipOverlay.get('dragging') === true) {
        weatherTipOverlay.set('dragging', false);
        showPointWeather(evt.coordinate);
    }
}

export default {
    // loadWindData,
    // searchMaxXY,
    // loadOtherData,
    createWeatherLayer,
    destoryWeatherLayer,
    createWindLayer,
    setWeatherOpacity,
    loadWeatherData,
    showPointWeather,
    getPointsWeather,
    changeWeatherData2Text,
    disableWeatherLayer,
    createWeatherTipLayer,
    closeWeatherTip,
    weatherTipDragging,
    weatherTipDragOver
    
}
